// 创建一个 Map 来存储每个接口的 mock 数据
export const mockData = new Map<string, any>();

// Mock 数据定义
mockData.set("getUserByToken", {
    nickname: "股神",
    phone: "1234567890",
    token: "1234567890",
});

mockData.set("login", {
    nickname: "模拟账户",
    phone: "19876543210",
    token: "1234567890",
});

mockData.set("register", {
    nickname: "RegisterMockUser",
    phone: "1112223333",
    token: "1234567890",
});

// 提供访问接口
export const getMockData = (functionName: string) => {
    return mockData.get(functionName);
};

export const mock:boolean = false;

